import { map, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { APIService } from './api.service';
import { Observable } from 'rxjs';
import { UserProfileResource } from '../../store/reducers/session-profile.reducer';
import { UserInfo } from '../../store/reducers/session-info.reducer';
import { Store } from '@ngrx/store';
import { selectBffBaseUrl } from '../../store/selectors/api-config.selectors';
import { selectOnboardingBaseUrl } from '../../store/selectors/onboarding-config.selectors';
import { NativeClientService } from '@shared/services/native-client.service';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class UserApiService {
  private basePath$: Observable<string>;
  private bff$: Observable<string>;
  private account$: Observable<string>;

  public userProfileUrl$: Observable<string>;
  public userForumNameUrl$: Observable<string>;

  constructor(
    private apiService: APIService,
    private http: HttpClient,
    private store: Store,
    private nativeClientService: NativeClientService,
  ) {
    this.bff$ = this.store.pipe(selectBffBaseUrl);
    this.account$ = this.store.pipe(selectOnboardingBaseUrl);
    this.basePath$ = this.bff$.pipe(map((url) => `${url}/app/user`));

    this.userProfileUrl$ = this.basePath$.pipe(
      map((basePath) => `${basePath}/profile`),
    );
    this.userForumNameUrl$ = this.basePath$.pipe(
      map((basePath) => `${basePath}/forum`),
    );
  }

  public getUserInfo(): Observable<UserInfo> {
    return this.basePath$.pipe(
      switchMap((basePath) =>
        this.apiService.callGetAPI<UserInfo>(`${basePath}/info`),
      ),
    );
  }

  public getUserProfile(): Observable<UserProfileResource> {
    return this.userProfileUrl$.pipe(
      switchMap((userProfileUrl) =>
        this.apiService.callGetAPI<UserProfileResource>(userProfileUrl),
      ),
    );
  }

  public getUserForumName(): Observable<UserProfileResource> {
    return this.userForumNameUrl$.pipe(
      switchMap((userForumUrl) =>
        this.apiService.callGetAPI<UserProfileResource>(userForumUrl),
      ),
    );
  }

  public saveUserProfile(
    userProfileObject: UserProfileResource,
  ): Observable<UserProfileResource> {
    return this.userProfileUrl$.pipe(
      switchMap((userProfileUrl) =>
        this.apiService.callPutAPI<UserProfileResource>(
          userProfileUrl,
          userProfileObject,
        ),
      ),
    );
  }

  public changePassword() {
    return this.account$.subscribe((url) => {
      if (this.nativeClientService.isNative) {
        const externalLink = {
          type: 'external_link',
          url: url + '/account/passwordChange',
        };
        window.alert(JSON.stringify(externalLink));
      } else {
        window.open(`${url}/account/passwordChange`, '_self');
      }
    });
  }

  public changeEmailAdress(body) {
    return this.bff$.pipe(
      switchMap((bff) =>
        this.apiService.callPostAPI(
          `${bff}/app/account/myaccount/$requestEmailChange`,
          body,
        ),
      ),
    );
  }

  public getHashedPatientId(patientId) {
    return this.bff$.pipe(
      switchMap((bff) =>
        this.apiService.callPostAPI(
          `${bff}/app/integration/polavis/encrypt`,
          patientId,
          'plain/text',
        ),
      ),
    );
  }

  public deletePatientAsRepresentative(patientId) {
    let params: HttpParams = new HttpParams();
    params = params.set('representativeAccountPatientId', patientId);

    return this.bff$.pipe(
      switchMap((bff) =>
        this.http.post(
          `${bff}/app/account/recordDelete`,
          {},
          {
            params,
            headers: {
              Accept: '*/*',
            },
          },
        ),
      ),
    );
  }
}
